var render = function render(_c,_vm){return _c('span',{ref:_vm.data.ref,staticClass:"badge bg-blue text-white",class:[_vm.data.class, _vm.data.staticClass],style:([_vm.data.style, _vm.data.staticStyle])},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }